var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"wrapper",style:(("width: " + _vm.size + "rem; height: " + _vm.size + "rem"))},[_c('KoderiaClose',{attrs:{"size":Number(_vm.size) * 0.5,"color":"white"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }